module.exports = __webpack_public_path__ + "img/Seher-Javed.c1ee0d7f.jpg";